<template>
    
    <span class="woocommerce-Price-amount amount" :class="{ negative: ( amount < 0 ) }">{{ formatAmount(amount) }}</span>

</template>

<script>
import Dinero from 'dinero.js'

export default {

    props: {
        amount: {
            required: true
        },        
        currency: {
            type: String,
            default: null,
            required: false
        }
    },

    methods: {

        formatAmount: function(amount) {

            if ( amount == null ) {
                return ''
            }

            if ( typeof amount !== 'number' && !(amount instanceof Number) ) {
                console.error("💥 La propriété 'amount' doit être de type Number.")
                return ''
            }

            // Prix et devise
            let price = { amount: Math.round( parseFloat(amount) * 100 ) }      
            if ( this.currency ) {
                price.currency = this.currency
            }
            let dinero = Dinero(price);
            
            // Affichage i18n
            switch ( this.currency ) {

                case 'GBP':
                    return dinero.setLocale('en-GB').toFormat('$0,0.00');

                case 'USD':
                    return dinero.setLocale('en-US').toFormat('$0,0.00');

                default:
                    return dinero.toFormat()
            }
        }
    }
}
</script>